<template>
  <base-dialog
    :visible="visible"
    :show-close="true"
    width="calc(100% - 400px)"
    class="dialog-wrap"
    border-radius="none"
    @open="open"
    @closed="closed"
  >
    <template v-slot:header>
      <div class="header-wrap">
        <div class="title">任务类型</div>
      </div>
    </template>
    <main>
      <div class="top-wrap">
        <div class="right">
          <div class="mRight10">
            <el-input
              v-model="searchText"
              size="small"
              placeholder="搜索任务类型"
              clearable
              @keyup.native.enter="search"
              @clear="search"
            >
              <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
            </el-input>
          </div>
          <!-- <el-button type="primary" size="small" @click="toCreate">新建</el-button> -->
        </div>
      </div>
      <div class="main-wrap">
        <div v-if="!showTable" v-loading="!showTable" class="empty"></div>
        <base-table
          v-else
          ref="baseTable"
          table-height="100%"
          :tableColumns="tableColumns"
          :tableData="filterData"
          :pageInfo="pageInfo"
          @row-click="rowClick"
          @selection-change="selectionChange"
          class="task-type-table"
        >
          <template v-slot:table-prefix>
            <el-table-column type="selection" width="50" align="center"></el-table-column>
          </template>
        </base-table>
      </div>
    </main>
    <template v-slot:footer>
      <base-button type="primary" @click="submit">保存</base-button>
      <base-button @click="closed">取消</base-button>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseTable from "@/components/BaseComponents/Table"
import BaseButton from "@/components/UIComponents/Button"
import { getTaskTypeList } from "@/api/project/project"
import { stringIncludes } from "@/utils/common"

export default {
  name: "task-type-dialog",
  components: { BaseDialog, BaseTable, BaseButton },
  props: {
    visible: Boolean
  },
  data() {
    const tableColumns = [
      {
        label: "任务类型",
        value: "name",
        align: "center"
      },
      {
        label: "描述",
        value: "description",
        align: "center"
      },
      {
        label: "关联工作表",
        value: "sheetStr",
        align: "center"
      },
      {
        label: "填写字段",
        value: "cidStr",
        align: "center"
      }
    ]
    return {
      tableColumns,
      searchText: "",
      showTable: true,
      taskTypeList: [],
      filterData: [],
      selectRows: [],
      pageInfo: {
        total: 100,
        currentPage: 1,
        pageSize: 20
      }
    }
  },
  watch: {
    "filterData.length": function(newVal) {
      this.pageInfo.total = newVal
    }
  },
  created() {
    this.getTaskTypeList()
  },
  methods: {
    open() {
      //
    },
    closed() {
      this.$emit("update:visible", false)
      this.searchText = ""
      this.filterData = this.taskTypeList
      this.$refs.baseTable.$refs.elTable.clearSelection()
    },
    search() {
      this.filterData = this.taskTypeList.filter(i => stringIncludes(i.name, this.searchText))
    },
    submit() {
      this.$emit("submit", this.selectRows)
    },
    getTaskTypeList() {
      return getTaskTypeList().then(res => {
        res.forEach(row => (row.sheetStr = row.appName + " / " + row.sheetName))
        this.taskTypeList = res
        this.filterData = this.taskTypeList
      })
    },
    rowClick(row) {
      this.$refs.baseTable.$refs.elTable.toggleRowSelection(row)
    },
    selectionChange(selection) {
      this.selectRows = selection
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-wrap {
  main {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .top-wrap {
    display: flex;
    align-items: center;
    margin: 8px 0;
    .right {
      margin-left: auto;
      display: flex;
      ::v-deep {
        .el-input-group__append {
          padding: 0 10px;
        }
      }
    }
  }
  .main-wrap {
    flex: 1 1;
    display: flex;
    overflow: hidden;
  }
  ::v-deep .el-dialog {
    min-width: 1080px;
    height: 86%;
    color: $color-font-first;
    .el-table__body-wrapper {
      .ps__rail-x {
        z-index: 10;
      }
    }
    .el-dialog__body {
      position: relative;
      padding: 0 !important;
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 100%;
      .task-type-table {
        flex: auto;
        overflow: hidden;
      }
    }
    .el-dialog__footer {
      position: absolute;
      bottom: -5px;
      right: 0;
      border: none;
      .footer {
        border: none;
      }
    }
  }
}
</style>
